import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    IconButton
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ReactSelect from 'react-select';
import Loading from 'components/Utils/loading';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { getHashEmpresa } from 'util/cobUtils';

import api from 'services/api';

const DialogEnviarMensagem = ({
    open,
    onClose,
    listaDestinatarios,
    loading,
    onFeedback,
    destinatarioInicial,
    mensagemParaMarcarComoLida,
    onMensagemMarcadaComoLida
}) => {
    const [assunto, setAssunto] = useState('');
    const [mensagemTexto, setMensagemTexto] = useState('');
    const [destinatario, setDestinatario] = useState(destinatarioInicial || null);
    const [loadingLocal, setLoadingLocal] = useState(false);
    const [marcarComoLida, setMarcarComoLida] = useState(true);
    const LIMITE_MENSAGEM = 10000;

    const [equipeSelecionada, setEquipeSelecionada] = useState(null);
    const [listaEquipes, setListaEquipes] = useState([]);
    const totalCaracteresMensagem = mensagemTexto.length;
    const mensagemExcedeLimite = totalCaracteresMensagem > LIMITE_MENSAGEM;

    useEffect(() => {
        setDestinatario(destinatarioInicial || null);
        setMarcarComoLida(true);
        listarEquipes();
    }, [destinatarioInicial, open]);

    async function listarEquipes() {
        const hashEmpresa = getHashEmpresa();
        const flag = 'GRUPO_COLAB';
        const response = await api.get(`/tabelas/${hashEmpresa}?flag=${flag}`);
        const data = await response.data.rows;
        setListaEquipes(data);
    }

    const handleEnviar = async () => {
        if (!destinatario || !assunto.trim() || !mensagemTexto.trim()) {
            if (onFeedback) onFeedback('Preencha os campos obrigatórios.', 'mb-3 bg-warning');
            return;
        }
        if (mensagemExcedeLimite) {
            if (onFeedback) onFeedback(`A mensagem ultrapassou o limite de ${LIMITE_MENSAGEM} caracteres.`, 'mb-3 bg-warning');
            return;
        }

        setLoadingLocal(true);
        try {
            const destinatarioIds = Array.isArray(destinatario)
                ? destinatario.map(d => d.ac_login)
                : [destinatario.ac_login];

            await api.post('/enviar_mensagens', {
                destinatarioIds,
                assunto,
                mensagem: mensagemTexto,
            });

            if (destinatarioInicial && marcarComoLida && mensagemParaMarcarComoLida) {
                await api.put(`/marcar_lida_mensagens/${mensagemParaMarcarComoLida.id}/lida`);
                if (onMensagemMarcadaComoLida) {
                    onMensagemMarcadaComoLida({
                        ...mensagemParaMarcarComoLida,
                        lido: 'Sim',
                    });
                }
            }

            setAssunto('');
            setMensagemTexto('');
            setDestinatario(null);
            if (onFeedback) onFeedback('Mensagem enviada com sucesso!', 'mb-3 bg-success');
            onClose();
        } catch (error) {
            if (onFeedback) onFeedback('Erro ao enviar mensagem.', 'mb-3 bg-danger');
        } finally {
            setLoadingLocal(false);
        }
    };

    const handleDefinirNegociadoresPorEquipe = () => {
        if (equipeSelecionada) {
            const negociadoresDaEquipe = listaDestinatarios.filter(negociador => negociador.idgrupo === Number(equipeSelecionada));
            setDestinatario(negociadoresDaEquipe);
        }
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>
                Enviar Mensagem
                <IconButton aria-label="fechar" onClick={onClose} style={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <div className="row">
                    <div className="col-12 mb-3" hidden={destinatarioInicial}>
                        <div className="d-flex" style={{ gap: 8 }}>
                            <TextField
                                fullWidth
                                select
                                size="small"
                                label="Equipe"
                                SelectProps={{
                                    native: true,
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="outlined"
                                onChange={(e) => setEquipeSelecionada(e.target.value)}
                                value={equipeSelecionada}
                                style={{ flex: 1 }}
                            >
                                <option value=''>Selecione a Equipe</option>
                                {listaEquipes.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.descricao}
                                    </option>
                                ))}
                            </TextField>
                            <Button
                                color="primary"
                                variant="outlined"
                                className="btn-md"
                                style={{ height: 40, whiteSpace: 'nowrap' }}
                                onClick={handleDefinirNegociadoresPorEquipe}
                            >
                                Buscar Negociadores
                            </Button>
                        </div>
                    </div>
                    <div className="col-12 mb-3" style={{ zIndex: 1200 }}>
                        <ReactSelect
                            options={listaDestinatarios}
                            value={destinatario}
                            onChange={setDestinatario}
                            isSearchable
                            isMulti={destinatarioInicial ? false : true}
                            closeMenuOnSelect={false}
                            placeholder="Selecione o destinatário"
                            getOptionLabel={(option) => option.nome}
                            getOptionValue={(value) => String(value.ac_login)}
                            noOptionsMessage={() => 'Sem mais opções para selecionar'}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                valueContainer: (base) => ({
                                    ...base,
                                    maxHeight: 120,
                                    overflowY: 'auto'
                                })
                            }}
                            isDisabled={!!destinatarioInicial}
                        />
                    </div>
                    <div className="col-12 mb-3">
                        <TextField
                            label="Assunto"
                            value={assunto}
                            onChange={(e) => setAssunto(e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="col-12">
                        <TextField
                            label="Mensagem"
                            value={mensagemTexto}
                            onChange={(e) => setMensagemTexto(e.target.value)}
                            multiline
                            rows={5}
                            fullWidth
                            variant="outlined"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            error={mensagemExcedeLimite}
                            helperText={`${totalCaracteresMensagem}/${LIMITE_MENSAGEM} caracteres${mensagemExcedeLimite ? ' - Limite excedido' : ''}`}
                            FormHelperTextProps={{
                                style: {
                                    marginLeft: 0,
                                    marginRight: 0,
                                },
                            }}
                            inputProps={{ style: { resize: 'vertical' } }}
                        />
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <div>
                        {destinatarioInicial && (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={marcarComoLida}
                                        onChange={e => setMarcarComoLida(e.target.checked)}
                                        color="primary"
                                        style={{ marginLeft: '15px' }}
                                    />
                                }
                                label={<span>marcar como lida</span>}
                            />
                        )}
                    </div>
                    <div>
                        <Button onClick={handleEnviar} color="primary" variant="contained" disabled={loading || mensagemExcedeLimite}>
                            Enviar
                        </Button>
                        <Button onClick={onClose} color="secondary" variant="outlined" disabled={loading} style={{ marginLeft: 8 }}>
                            Cancelar
                        </Button>
                    </div>
                </div>
            </DialogActions>

            <Loading carregar={loadingLocal} />
        </Dialog>
    )
};

export default DialogEnviarMensagem;